module.exports = {
  footerText:
    'Copyright © Administradora de servicios médicos MoldeArte, todos los derechos reservados.',
};
